export const auth = {
  'auth.welcome': 'Welcome to subvention360',
  'auth.welcomeBack': 'Welcome back!',
  'auth.tagline': 'AI-Powered Subsidy Applications • 2-Minute Setup • 90% Faster',
  'auth.noCreditCard': '✓ No credit card required',
  'auth.login': 'Log In',
  'auth.signUp': 'Sign Up',
  'auth.loginTitle': 'Log in to your account',
  'auth.loginDescription': 'Enter your credentials to access your dashboard',
  'auth.signupTitle': 'Create your account',
  'auth.signupDescription': 'Get started in under 2 minutes • No upfront details required',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Confirm Password',
  'auth.enterEmail': 'Enter your email',
  'auth.enterPassword': 'Enter your password',
  'auth.confirmPasswordPlaceholder': 'Confirm your password',
  'auth.forgotPassword': 'Forgot password?',
  'auth.loggingIn': 'Logging in...',
  'auth.signingUp': 'Signing up...',
  'auth.backToHome': 'Back to home',
  'auth.resetPasswordTitle': 'Reset password',
  'auth.resetPasswordDescription': 'Enter your email to receive a reset link',
  'auth.sendResetLink': 'Send reset link',
  'auth.sendingResetLink': 'Sending...',
  'auth.cancel': 'Cancel',
  'auth.backToLogin': 'Back to login',
  'auth.resetEmailSent': 'Password reset email sent',
  'auth.resetEmailDescription': 'Check your email for a link to reset your password.',
  'auth.resetFailed': 'Password Reset Failed',
  'auth.resetFailedGeneric': 'Failed to send password reset email. Please try again.',
  'auth.resetFailedUserNotFound': 'No account found with this email address.',
  'auth.resetFailedTooManyRequests': 'Too many requests. Please wait a few minutes before trying again.',
  'auth.success': 'Success',
  'auth.loginSuccess': 'Successfully logged in',
  'auth.signupSuccess': 'Account created successfully! Please check your email for verification.',
  'auth.loginFailed': 'Login failed',
  'auth.signupFailed': 'Sign up failed',
  'auth.passwordsDoNotMatch': 'Passwords do not match',
  'auth.invalidCredentials': 'Hmm, those credentials don\'t match. Please double-check your email and password.',
  'auth.emailNotConfirmed': 'Almost there! Please check your email and click the confirmation link to complete signup.',
  'auth.tooManyRequests': 'Whoa, slow down! Please wait a few minutes before trying again.',
  'auth.alreadyRegistered': 'Looks like you already have an account! Please sign in instead.',
  'auth.accountNotFound': 'No account found with this email address.',
  'auth.invalidEmail': 'That email doesn\'t look quite right. Please check and try again.',
  'auth.userNotFound': 'This Google account is not yet registered with subvention360. Please sign up with email and password first.',
  'auth.somethingWentWrong': 'Something went wrong. Please try again.',
  'auth.accountCreated': 'Account created successfully!',
  'auth.checkEmailVerification': 'Please check your email to verify your account.',
  'auth.orContinueWith': 'Or continue with',
  'auth.continueWithGoogle': 'Continue with Google',
  'auth.noAccount': 'Don\'t have an account?',
  'auth.alreadyHaveAccount': 'Already have an account?',
  'auth.signUpHere': 'Sign up here',
  'auth.signInHere': 'Sign in here',

  // Password requirements
  'auth.passwordRequirements': 'Password Requirements:',
  'auth.passwordReq.minChars': 'At least 6 characters',
  'auth.passwordReq.lowercase': 'One lowercase letter (a-z)',
  'auth.passwordReq.uppercase': 'One uppercase letter (A-Z)',
  'auth.passwordReq.number': 'One number (0-9)',
  'auth.passwordReq.special': 'One special character (!@#$%*()_+-=[]{}|;\':"<>?,.~/~)',
  'auth.passwordPlaceholder': 'Password: lowercase, UPPERCASE, 123, !@#',
  'auth.quickProfileSetup': '⚡ After signup, complete your profile in just 2 quick steps',

  // Session monitoring
  'auth.sessionExpiringSoon': 'Session expiring soon',
  'auth.sessionExpiryMessage': 'Your session will expire in {{minutesUntilExpiry}} minutes. Click to refresh.',
  'auth.sessionExpiryMessage1Min': 'Your session will expire in 1 minute. Please refresh to stay logged in.',
  'auth.refreshSession': 'Refresh',
  'auth.sessionRefreshed': 'Session refreshed',
  'auth.sessionRefreshedMessage': 'You can continue working.',
  'auth.sessionRefreshFailed': 'Session refresh failed',
  'auth.sessionRefreshErrorMessage': 'Please log in again.',
  'auth.rememberMe': 'Remember me',
  'auth.staySignedIn': 'Stay signed in',
  'auth.sessionTimeout': 'Session timeout',
  'auth.sessionTimeoutDescription': 'Your session has expired due to inactivity.',
} as const;
